import { render, staticRenderFns } from "./CorporateActivityMyAccount.vue?vue&type=template&id=2b8fa9a8"
import script from "./CorporateActivityMyAccount.vue?vue&type=script&lang=js"
export * from "./CorporateActivityMyAccount.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports